// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import createSvgIcon from '../utils/createSvgIcon';
import React from "react";


export default createSvgIcon(
  <><path d="M6.000 12.500 L 6.000 13.000 12.500 13.000 L 19.000 13.000 19.000 12.500 L 19.000 12.000 12.500 12.000 L 6.000 12.000 6.000 12.500 " stroke="none" fill="black" fillRule="evenodd"></path></>, 
'MinusIcon', {
  viewBox: '0 0 24 24',
  height: '24',
  width: '24',
});